export default __webpack_public_path__ + "static/media/I0006.5f76e76c.png";